import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../images/icon-popup-close.png'


const _withScopeId = n => (_pushScopeId("data-v-68f717b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "popup-wrapper"
}
const _hoisted_2 = ["src"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = {
  key: 1,
  class: "mask"
}

import { onMounted } from 'vue';

  type IProps = {
    text?: string,
    btnText?: string,
    btnColor?: string,
    hiddenCloseIcon?: boolean,
    modelValue:boolean,
    icon: string;
    iconBgColor: string;
  }

  
export default /*#__PURE__*/_defineComponent({
  props: {
    text: null,
    btnText: null,
    btnColor: null,
    hiddenCloseIcon: { type: Boolean, default: false },
    modelValue: { type: Boolean },
    icon: null,
    iconBgColor: null
  },
  emits: ['update:modelValue', 'clickBtn'],
  setup(__props: any, { emit: emits }) {

const props = __props as { text?: string, btnText?: string, btnColor?: string, hiddenCloseIcon: boolean, modelValue:boolean, icon: string, iconBgColor: string }

  

  

  function handleClickBtn() {
    emits('update:modelValue', false);
    emits('clickBtn');
  }

  onMounted(() => {});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (!props.hiddenCloseIcon)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: _imports_0,
                class: "icon-close",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update:modelValue', false)))
              }))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "box-icon",
            style: _normalizeStyle({ background: __props.iconBgColor })
          }, [
            _createElementVNode("img", {
              src: __props.icon,
              alt: ""
            }, null, 8, _hoisted_2)
          ], 4),
          _createElementVNode("div", {
            class: "text",
            innerHTML: props.text
          }, null, 8, _hoisted_3),
          _createElementVNode("div", {
            class: "btn",
            style: _normalizeStyle({backgroundColor: props.btnColor}),
            onClick: handleClickBtn
          }, _toDisplayString(props.btnText), 5)
        ]))
      : _createCommentVNode("", true),
    (props.modelValue)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4))
      : _createCommentVNode("", true)
  ], 64))
}
}

})